<div class="w3-large" style="float: right;">
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Headline -->
<p class="text-3xl font-bold">Data Access Policy Settings</p>

<!-- My Data Policy Data -->
<div class="shadow-md border rounded w-full mt-4 flex flex-col p-4">

    <div class="flex flex-row justify-between w-full ">
        <div class="flex items-center justify-center h-full text-xl font-bold">
            My Data
        </div>

        <div class="flex flex-row text-center items-center">

            <span class="pr-2 text-lg font-bold">View Mode</span>

            <mat-button-toggle-group [(ngModel)]="orgDataViewMode" class="flex border-2 ">

                <mat-button-toggle value="pri" class="rounded">
                    Private
                </mat-button-toggle>
                <mat-button-toggle value="pub" class="rounded">
                    Public
                </mat-button-toggle>

            </mat-button-toggle-group>

        </div>

    </div>

    <hr class="my-2 border-2 " />

    <div class="w-full text-lg font-bold mb-4">
        <p>Report Visibility :</p>
    </div>

    <div class="grid grid-cols-2 gap-4 w-full ">

        <!-- Chemical -->
        <div class="flex flex-row">

            <p class="flex text-lg font-semibold w-1/5">
                Chemical
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="orgChemicalViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>

        <!-- Energy -->
        <div class="flex flex-row justify-end">
            <p class="flex text-lg font-semibold w-1/5">
                Energy
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="orgEnergyViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>

        <!-- Water -->
        <div class="flex flex-row">

            <p class="flex text-lg font-semibold w-1/5">
                Water
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="orgWaterViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>
        </div>

        <!-- Facility -->
        <div class="flex flex-row justify-end ">

            <p class="flex text-lg font-semibold w-1/5">
                Facility
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="orgFacilityViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>

    </div>

</div>

<!-- My Suplier Policy Data -->
<div class="shadow-md border rounded w-full mt-4 flex flex-col p-4">

    <div class="flex flex-row justify-between w-full ">
        <div class="flex items-center justify-center h-full text-xl font-bold">
            My Suplier
        </div>

        <div class="flex flex-row text-center items-center">

            <span class="pr-2 text-lg font-bold">View Mode</span>

            <mat-button-toggle-group [(ngModel)]="suplierDataViewMode" class="flex border-2 ">

                <mat-button-toggle value="pri" class="rounded">
                    Private
                </mat-button-toggle>
                <mat-button-toggle value="pub" class="rounded">
                    Public
                </mat-button-toggle>

            </mat-button-toggle-group>

        </div>

    </div>

    <hr class="my-2 border-2 " />

    <div class="w-full text-lg font-bold mb-4">
        <p>Report Visibility :</p>
    </div>

    <div class="grid grid-cols-2 gap-4 w-full ">

        <!-- Chemical -->
        <div class="flex flex-row">

            <p class="flex text-lg font-semibold w-1/5">
                Chemical
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="suplierChemicalViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>

        <!-- Energy -->
        <div class="flex flex-row justify-end">

            <p class="flex text-lg font-semibold w-1/5">
                Energy
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="suplierWaterViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>
        </div>

        <!-- Water -->
        <div class="flex flex-row">

            <p class="flex text-lg font-semibold w-1/5">
                Water
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="suplierEnergyViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>
        </div>

        <!-- Facility -->
        <div class="flex flex-row justify-end ">

            <p class="flex text-lg font-semibold w-1/5">
                Facility
            </p>

            <div class="flex flex-row text-center items-center">

                <mat-button-toggle-group [(ngModel)]="suplierFacilityViewMode" class="flex border-2 ">

                    <mat-button-toggle value="F" class="rounded">
                        Full
                    </mat-button-toggle>
                    <mat-button-toggle value="H" class="rounded">
                        High Level
                    </mat-button-toggle>

                </mat-button-toggle-group>

            </div>

        </div>

    </div>

</div>

<!-- Relationship Data -->
<div class="shadow-md border rounded w-full mt-4 flex flex-col p-4">

    <div class="flex flex-row justify-between w-full ">

        <div class="flex items-center justify-center h-full text-xl font-bold">
            Relationship Data
        </div>

    </div>

    <hr class="my-2 border-2 " />

    <div class="w-full ">

        <table class="w-full ">

            <!-- Scope Data -->
            <tr class="py-2">
                <td>
                    <p class="flex text-lg font-semibold "> Scope </p>
                </td>
                <td>
                    <mat-form-field>
                        <mat-select [(ngModel)]="selectedScope" >
                          <mat-option [value]="'in'"> In </mat-option>
                          <mat-option [value]="'out'"> Out </mat-option>
                        </mat-select>
                      </mat-form-field>
                </td>

            </tr>

            <!-- Key Supplier-->
            <tr class="py-2">

                <td>
                    <p class="flex text-lg font-semibold"> Key Supplier </p>
                </td>

                <td class="pb-4">
                    <mat-button-toggle-group [(ngModel)]="keySupplierViewMode" class="border-2 ">
                        <mat-button-toggle value="true" class="rounded">
                          Yes
                        </mat-button-toggle>
                        <mat-button-toggle value="false" class="rounded">
                          No
                        </mat-button-toggle>
                      </mat-button-toggle-group>
                </td>
            </tr>

            <!-- Department Data -->
            <tr class="py-2">
                <td>
                    <p class="flex text-lg font-semibold "> Department </p>
                </td>
                <td>
                    <mat-form-field appearance="fill" class="w-full">
                        <input matInput [(ngModel)]="department" >
                      </mat-form-field>
                </td>
            </tr>

            <!-- Business Volume Data -->
            <tr class="py-2">

                <td>
                    <p class="flex text-lg font-semibold "> Business Volume </p>
                </td>

                <td>
                    <mat-form-field appearance="fill" class="w-full">
                        <input matInput [(ngModel)]="businessVolume" >
                      </mat-form-field>
                </td>

            </tr>

            <!-- Supplier Type -->
            <tr class="py-2">
                <td>
                    <p class="flex text-lg font-semibold "> Supplier Type </p>
                </td>
                <td>
                    <mat-form-field appearance="fill" class="w-full">
                        <input matInput [(ngModel)]="supplierType" >
                    </mat-form-field>
                </td>
            </tr>

            <!-- Vendor Partner ID Data -->
            <tr class="py-2">

                <td>
                    <p class="flex text-lg font-semibold "> Vendor Partner ID </p>
                </td>

                <td>
                    <mat-form-field appearance="fill" class="w-full">
                        <input matInput [(ngModel)]="vendorPartner" >
                    </mat-form-field>
                </td>
            </tr>

            <!-- Other Details Data -->
            <tr class="py-2">
                <td>
                    <p class="flex text-lg font-semibold "> Other Details </p>
                </td>
                <td class="pr-4">
                    <textarea matInput [(ngModel)]="otherDetails" class="w-full border border-blue-500 rounded-lg p-2"></textarea>
                </td>
            </tr>

        </table> 

    </div>

</div>

<div *ngIf="isBrandLoggedIn" class="mt-4 w-full flex justify-end items-end">

    <button mat-raised-button class="rounded mr-4" (click)="resetModifiedPolicyData()">Reset</button>
    <button mat-raised-button color="primary" class="rounded" (click)="saveOrUpdatePolicyData()">Save Data Access
        Policy</button>

</div>